export interface checkInDataset {
  firstName: string;
  lastName: string;
  origin: string;
  confirmationNumber: string;
  intent: string;
}
